export function getFlagClass(number: AllowedFlag): string {
  if (number.msisdn && number.msisdn.includes('webcall')) {
    return 'webcall';
  } else {
    return number.isoCountry && number.isoCountry.toLowerCase();
  }
}

interface AllowedFlag {
  msisdn?: string;
  isoCountry?: string;
}
